import ErrorIcon from "@mui/icons-material/Error";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import InfoIcon from "@mui/icons-material/Info";
import React, { useMemo } from "react";
import PropTypes from "prop-types";

export const DisplayIcon = ({ messageType, disabled }) => {
  const sx = useMemo(() => ({ height: "25px", opacity: disabled ? 0.7 : 1 }), [disabled]);

  switch (messageType) {
    case "Warning":
      return <WarningRoundedIcon color="warning" sx={sx} />;
    case "Error":
      return <ErrorIcon color="error" sx={sx} />;
    case "Info":
      return <InfoIcon color="primary" sx={sx}></InfoIcon>;
    default:
      return <></>;
  }
};

DisplayIcon.propTypes = {
  messageType: PropTypes.string,
  disabled: PropTypes.bool
};
